import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import { reduxForm, Field, submit } from 'redux-form/immutable';

import { nameOrEmail, toJS } from '../../../utils/helper';

import { fetchProfileRoutine } from '../../../redux/routines';
import { hideDialog } from '../../../redux/actions/dialogs';
import { renderTextField } from '../../../utils/reduxforms';
import Gravatar from '../../Common/Gravatar';
import ReduxDialog from '../../Common/ReduxDialog';

import styles from './styles';
import Loading from '../../Common/Loading';
import { PROFILE_DIALOG } from '../../../redux/constants/dialogs';

class ProfileDialog extends Component {

  componentWillMount() {
    // console.log('fetchProfile');
    this.props.fetchProfile();
  }

  // handleImageUpload = (image, data) => {
  //   // FireBaseTools.uploadEmployeeImage(image, data);
  //   this.props.setImage(null, image);
  // };

  render() {
    const { profile, dispatch, hideDialog, loading } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(PROFILE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => dispatch(submit('Profile'))}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={PROFILE_DIALOG}
        title={nameOrEmail(profile) || 'Profile'}
        actions={actions}
        modal={false}
        onRequestClose={() => this.props.hideDialog(PROFILE_DIALOG)}
        maxWidth="sm"
        fullWidth
      >
        <div>
          {!loading && profile ? <form name="customer">
            {/*{ this.state.message ? <p>{this.state.message}</p> : null }*/}
            <div style={styles.row}>
              <div style={styles.profile}>
                <Gravatar
                  email={profile.email}
                />
              </div>
              <div style={styles.main}>
                <div style={styles.row}>
                  <Field
                    name="firstName"
                    component={renderTextField}
                    label="First Name"
                    fullWidth
                    disabled
                  />
                  <Field
                    name="lastName"
                    component={renderTextField}
                    label="Last Name"
                    fullWidth
                    disabled
                  />
                </div>
                <div className="form-group">
                  <Field
                    name="email"
                    component={renderTextField}
                    label="Email"
                    fullWidth
                    disabled
                  />
                </div>
                {/*<div className="form-group">*/}
                {/*<Field*/}
                {/*name="displayName"*/}
                {/*component={TextField}*/}
                {/*label="Display Name"*/}
                {/*InputLabelProps={{shrink: true}}*/}
                {/*fullWidth*/}
                {/*defaultValue={this.props.currentUser.displayName}*/}
                {/*style={commonStyles.input}*/}
                {/*/>*/}
                {/*</div>*/}
              </div>
            </div>
          </form> : <Loading/>}
        </div>
      </ReduxDialog>
    );
  }
}

ProfileDialog.propTypes = {
  hideDialog: PropTypes.func.isRequired,
  profile: PropTypes.object,
};

const form = reduxForm({
  form: 'Profile',  // a unique identifier for this form
  // enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    // const payload = values.toJS();
    // if (props.employee.image) {
    //   // firebaseStorage.ref(getAccountPath(`/employees/${props.employee.image}`)).getDownloadURL().then((image) => {
    //   //   props.setImageDownloadUrl(image);
    //   //   const profileDetail = {
    //   //     displayName: payload.displayName,
    //   //     photoURL: image,
    //   //   };
    //   //   props.updateUser(profileDetail);
    //   // });
    // } else if (props.currentUser.displayName !== payload.displayName) {
    //   props.updateUser({ displayName: payload.displayName });
    // }
    // if (props.currentUser.email !== payload.email) {
    //   props.updateUserEmail(payload.email);
    // }
    props.hideDialog(PROFILE_DIALOG);
  },
})(ProfileDialog);

function mapStateToProps(state) {
  const profile = state.getIn(['authentication', 'profile', 'data']);
  return {
    loading: state.getIn(['authentication', 'profile', 'loading']),
    profile: toJS(profile),
    initialValues: profile,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchProfile: fetchProfileRoutine.trigger,
    // updateUser,
    // updateUserEmail,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/ProfileDialog/index.js